import React from 'react';
// import { useRouter } from 'next/router';
import Sticky from 'react-stickynode';
import { useAppState } from '../contexts/app/app.provider';
import Header from './header/header';
import { LayoutWrapper } from './layout.style';
import { isCategoryPage } from './is-home-page';
import MobileHeader from './header/mobile-header';

// type LayoutProps = {
//   className?: string;
//   token?: string;
// };

const Layout = ({
  className,
  children,
  // deviceType: { mobile, tablet, desktop },
  token,
}) => {
  const isSticky = useAppState('isSticky');
  // const { pathname, query } = useRouter();
  // const type = pathname === '/restaurant' ? 'restaurant' : query.type;
  const type = '';

  const isHomePage = isCategoryPage(type);
  return (
    <LayoutWrapper className={`layoutWrapper ${className}`}>
      <Sticky enabled={isSticky} innerZ={1001}>
        <MobileHeader
          className={`${isSticky ? 'sticky' : 'unSticky'} ${
            isHomePage ? 'home' : ''
          } desktop`}
        />

        <Header
          className={`${isSticky && isHomePage ? 'sticky' : 'unSticky'} ${
            isHomePage ? 'home' : ''
          }`}
        />
      </Sticky>
      {children}
    </LayoutWrapper>
  );
};

export default Layout;
